import styles from './HeaderButtonContainer.module.scss';
import { HEADER_BUTTONS } from '../../TabConstants';
import clsx from 'clsx';
import { useEffect, useRef, useState } from 'react';
import isNil from 'lodash/isNil';
import ThreeDotMenu from '../../../../../../common/ThreeDotMenu/ThreeDotMenu';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import {
    ACCESS_TIERS,
    ACCESS_TYPES,
    MANAGE_USERS_TABS,
    PROFILE_GENERATION_STATUS,
    REFRESH_UNLOCK_POS,
    RESTRICTED_ROLES,
} from '../../../../../../store/investor/constants';
import {
    getPlatformUserId,
    getSubdomain,
    getUserTypeList,
    isEmpty,
    isLenderType,
    isRestrictedUser,
    openCompanySummonTab,
} from '../../../../../../utils/utils';
import {
    handleDealApplicationDrawer,
    setBureauKycConsentData,
    setComposeEmailModal,
    setEngagementLetterData,
    setNDAData,
    setOnePagerData,
    setShowInviteUserModal,
    setShowRefreshReport,
    setShowUnlockAicaConfirmation,
} from '../../../../../../store/investor/action';
import { USER_TYPE } from '../../../../../../utils/constants/user';
import { fetchInternalSummonAicaData, InternalSummonAicaDataPayload, InternalSummonUserType } from '../../../../../../store/user/actions';
import { updateQueryParams } from '../../../../../../utils/searchParamUtils';
import { useParams, useSearchParams } from 'react-router-dom';
import SideDrawer from '../../../../../../common/_custom/SideDrawer/SideDrawer';
import UploadData from '../../../../../Company/UploadData/UploadData';
import AddAssessee from '../../../../../Company/AddAssessee/AddAssessee';
import {
    AICA_CREATE_DEAL,
    AICA_BUREAU_KYC_CONSENT_EDIT,
    AICA_ENGAGEMENT_LETTER_VIEW,
    AICA_GENERATE_PDF_REPORT,
    AICA_NDA_VIEW,
    AICA_ONEPAGER_VIEW,
    AICA_UNLOCK_REFRESH_OPENED,
    AICA_BUREAU_KYC_CONSENT_VIEW,
} from '../../../../../../utils/constants/mixpanelEvents/investorEvents';
import { Mixpanel } from '../../../../../../utils/mixpanel';
import { getInvestmentReport, getAllUsers } from '../../../../../../store/investor/apiHelpers';
import { toast } from 'react-toastify';
import { GENERATION_STATUS } from '../../../../../../common/ManageDealDrawer/InvestmentReport/InvestmentReport';
import { FILE_SHARE_STATUS } from '../../../../../../common/ManageDealDrawer/DealDrawerConstants';
import { downloadFile } from '../../../../../Company/UploadJourney/components/UploadCard/utils/api/helpers';
import { moveCompanyToNewTier } from '../../../../../../store/investor/investorApiHelper';
import AIText from '../../../../../../common/AIText/AIText';
import { COMPOSE_EMAIL_SOURCE } from '../../../../../../common/NeedInfoV2/NeedInfoV2Constants';
import { ManageUserDrawer } from '../../../../../Company/UploadData/components/ManageUserDrawer';
import { OrgUser } from '../../../../../Investor/ManageUser/OrgBasedUsersTable/OrgBasedUsersTable';
import { fetchCompanyOverviewData } from '../../../../../../store/dashboard/overview/actions';
import { setDashboardConfig } from '../../../../../../store/dashboard/actions';
import { VISIBILITY_KEYS } from '../../../../../../utils/constants/visibilityKeys';
import { useFeatureVisibility } from '../../../../../../utils/useVisibilityConfig';
import NotificationModal from '../../../../../../common/NotificationModal/NotificationModal';
import { getOwnerDetails } from '../../../../../../utils/utils';
import { NOTIFICATION_MODAL } from '../../../../../../utils/constants/commonConstants';

interface OrgInfo {
    owners?: {
        owner?: string;
    };
}
type HeaderButtonContainerProps = {
    selectedCompany: any;
    refreshReportStatus: string;
    downloadPDFStatus: string;
    exportData: () => void;
};

const HeaderButtonContainer = (props: HeaderButtonContainerProps) => {
    const dispatch = useAppDispatch();
    const onePagerLoading = useAppSelector((state) => state.investor.onePager.loading);

    const { selectedCompany } = props;
    const [mainButtonHovered, setMainButtonHovered] = useState('');
    const [showManageUsers, setShowManageUsers] = useState(false);
    const [selectedOrgUsers, setSelectedOrgUsers] = useState<OrgUser[]>([]);
    const investorData = useAppSelector((state) => state.investor);
    const [searchParams, setSearchParams] = useSearchParams();
    const dashboardConfig = useAppSelector((state) => state.dashboard.dashboardReducer.config);
    const permissions = investorData.permissions;
    const isProfileLocked = selectedCompany?.profileGenerationStatus === 'LOCKED';
    const user = useAppSelector((state) => state.user);
    const platformData = useAppSelector((state) => state.user.domainMetadata);
    const isUserRestricted = isRestrictedUser(user?.userData?.roles?.[0], RESTRICTED_ROLES);
    const isDemoProfile = user.domainMetadata?.demoOrgId === selectedCompany?.assesseeOrgId;
    const isLender = isLenderType(user.userData?.accountType);
    const isPartner = user.userData?.accountType === USER_TYPE.PARTNER;
    const editUserModal = useAppSelector((state) => state.investor.editUserModal);
    const { unlockAicaVisibility } = useFeatureVisibility({
        unlockAicaVisibility: VISIBILITY_KEYS.UNLOCK_AICA.ENABLED,
    });
    const [queryParams, setQueryParams] = useSearchParams();
    const params = useParams();
    const showUploader = queryParams.get('upload') === 'true';
    const isSummonUser = !isNil(sessionStorage.getItem('auth_token'));

    const showInviteUser = useAppSelector((state) => state.investor.showInviteUser);
    const userData = useAppSelector((state) => state.user.userData);
    const userType = userData.accountType;
    const orgInfo = useAppSelector((state): OrgInfo => state.investor.orgInfo);
    const ownerId = orgInfo?.owners?.owner;
    const ownerDropdownOptions = useAppSelector((state) => state.investor.ownerDropdownOptions);
    const partnerOwner = ownerDropdownOptions.find((item) => item.userId === ownerId);

    const openCreateDealDrawer = () => {
        dispatch(
            handleDealApplicationDrawer({
                open: true,
                source: 'createDeal',
                heading: 'Create Deal',
                subHeading: selectedCompany.orgName,
                width: '67%',
                profileGenerationStatus: selectedCompany?.profileGenerationStatus,
            }),
        );
        searchParams.set('dealCreated', 'true');
        setSearchParams(searchParams);

        Mixpanel.track(AICA_CREATE_DEAL, {
            userRole: user?.userData?.accountType,
            pnoPlatform: getSubdomain(),
            pnoId: platformData?.investorOrgId,
            userId: user?.userData?.userId,
            currentUrl: window.location.href,
            organizationId: selectedCompany?.assesseeOrgId,
        });
    };

    const trackViewBureauKycConsent = () => {
        Mixpanel.track(AICA_BUREAU_KYC_CONSENT_VIEW, {
            userRole: user?.userData?.accountType,
            pnoPlatform: getSubdomain(),
            userId: user?.userData?.userId,
            currentUrl: window.location.href,
            organizationId: params?.id || selectedCompany?.assesseeOrgId,
        });
    };

    const summon = () => {
        const platformUserId = getPlatformUserId();
        const payload: InternalSummonAicaDataPayload = {
            parentOrgId: platformData?.investorOrgId as string,
            parentEmailId: user.userData.investorPrimaryEmail,
            orgId: selectedCompany?.assesseeOrgId,
            userType: InternalSummonUserType.ASSESSEE,
            requesterUserId: platformUserId,
        };
        dispatch(
            fetchInternalSummonAicaData(payload, {
                onSuccess: (userData) => {
                    openCompanySummonTab(userData);
                },
            }),
        );
    };

    const addCompanyToPortfolio = (orgId: string, orgName: string, profileGenerationStatus: string): void => {
        // If the profile is locked, ask the user to unlock it first
        if (profileGenerationStatus === PROFILE_GENERATION_STATUS.LOCKED) {
            dispatch(setShowUnlockAicaConfirmation({ showUnlockAicaConfirmation: true, orgId, orgName }));
            return;
        }

        // If the profile is unlocked, add the company to the portfolio
        moveCompanyToNewTier(
            {
                assesseeOrgId: orgId,
                inviteType: ACCESS_TIERS.TRACK,
            },
            {
                onSuccess: () => {
                    toast.success(`Added to Portfolio: ${orgName}`);
                    queryParams.append('portfolioSuccess', 'true');
                    updateQueryParams(queryParams, setQueryParams, {}, location);
                },
            },
        );
    };

    useEffect(() => {
        if (editUserModal.refetchUsers) {
            fetchOrgUsers();
        }
    }, [editUserModal.refetchUsers]);

    // To retain the three dot menu actions after refresh on company header
    useEffect(() => {
        dispatch(
            fetchCompanyOverviewData({
                assesseeOrgId: params.id as string,
                investorOrgId: user.userData.investorOrgId,
                partnerUserId: user.userData.userId,
                onSuccess: (data, actionCta) => {
                    dispatch(setDashboardConfig({ ...dashboardConfig, actionCta }));
                },
            }),
        );
    }, [params.id, user.userData.investorOrgId, user.userData.userId]);

    const fetchOrgUsers = async () => {
        const userType = getUserTypeList(MANAGE_USERS_TABS.COMPANY);
        const users = await getAllUsers({
            pageSize: 20,
            pageNumber: 1,
            orgId: selectedCompany?.assesseeOrgId,
            userType,
        });
        setSelectedOrgUsers(users.userDetails);
    };

    const openManageUsersDrawer = async () => {
        try {
            updateQueryParams(searchParams, setSearchParams, { category: MANAGE_USERS_TABS.COMPANY }, location);
            await fetchOrgUsers();
            setShowManageUsers(true);
        } catch (error) {
            console.error('Error fetching users:', error);
            toast.error('Failed to fetch users. Please try again later.');
        }
    };

    const unlockRefreshReport = () => {
        if (unlockAicaVisibility.show) {
            setShowTalkToUsModal(true);
        } else {
            dispatch(setShowRefreshReport(true));
        }

        Mixpanel.track(AICA_UNLOCK_REFRESH_OPENED, {
            userRole: user?.userData?.accountType,
            pnoPlatform: getSubdomain(),
            userId: user?.userData?.userId,
            currentUrl: window.location.href,
            organizationId: selectedCompany?.assesseeOrgId,
            accessedFrom: REFRESH_UNLOCK_POS.THREE_DOT_MENU,
        });
    };

    const ACTION_MENU_MAP = {
        VIEW_ONE_PAGER: {
            name: onePagerLoading ? (
                <AIText text="Please Wait" showLoadingDots={true} style={{ fontFamily: 'inherit' }} />
            ) : (
                'View One Pager'
            ),
            keepOpenOnClick: true,
            onClick: () => {
                dispatch(
                    setOnePagerData({
                        open: true,
                        assesseeOrgId: params.id as string,
                        source: 'REPORT_TOP_BAR',
                    }),
                );

                Mixpanel.track(AICA_ONEPAGER_VIEW, {
                    userRole: user?.userData?.accountType,
                    pnoPlatform: getSubdomain(),
                    pnoId: platformData?.investorOrgId,
                    userId: user?.userData?.userId,
                    currentUrl: window.location.href,
                    organizationId: selectedCompany?.assesseeOrgId,
                });
            },
        },
        VIEW_ENGAGEMENT_LETTER: {
            name: 'View Engagement Letter',
            onClick: () => {
                dispatch(
                    setEngagementLetterData({
                        open: true,
                        orgId: params.id as string,
                        source: 'REPORT_TOP_BAR',
                        companyName: selectedCompany?.orgName,
                    }),
                );

                Mixpanel.track(AICA_ENGAGEMENT_LETTER_VIEW, {
                    userRole: user?.userData?.accountType,
                    pnoPlatform: getSubdomain(),
                    userId: user?.userData?.userId,
                    currentUrl: window.location.href,
                    organizationId: selectedCompany?.assesseeOrgId,
                });
            },
        },
        VIEW_BUREAU_KYC_CONSENT: {
            name: 'View Bureau & KYC Consent',
            onClick: () => {
                trackViewBureauKycConsent();
                dispatch(
                    setBureauKycConsentData({
                        open: true,
                        source: 'REPORT_TOP_BAR',
                        orgId: params?.id || selectedCompany?.assesseeOrgId,
                        companyName: selectedCompany?.orgName,
                    }),
                );
            },
        },
        VIEW_NDA: {
            name: 'View NDA',
            onClick: () => {
                dispatch(
                    setNDAData({
                        open: true,
                        orgId: params.id as string,
                        source: 'REPORT_TOP_BAR',
                        companyName: selectedCompany?.orgName,
                    }),
                );

                Mixpanel.track(AICA_NDA_VIEW, {
                    userRole: user?.userData?.accountType,
                    pnoPlatform: getSubdomain(),
                    userId: user?.userData?.userId,
                    currentUrl: window.location.href,
                    organizationId: selectedCompany?.assesseeOrgId,
                });
            },
        },
        UNLOCK_REPORT: {
            name: 'Unlock/Refresh Report',
            onClick: unlockRefreshReport,
        },
        CREATE_DEAL: {
            name: 'Create Deal',
            onClick: openCreateDealDrawer,
        },
        INVITE_USER: {
            name: 'Invite User',
            onClick: () => {
                dispatch(setShowInviteUserModal(true));
            },
        },
        SUMMON: {
            name: 'View Account',
            onClick: summon,
        },
        DOWNLOAD_IR: {
            name: 'Export Investment Report',
            onClick: () => {
                toast.warn(
                    'Generating Investment Report.\n' + "It will automatically download within 2 mins, please don't close this tab.",
                );
                fetchInvestmentReport(selectedCompany, pollingCount);
            },
        },
        ADD_TO_PORTFOLIO: {
            name: 'Add to Portfolio',
            onClick: () =>
                addCompanyToPortfolio(selectedCompany?.assesseeOrgId, selectedCompany?.orgName, selectedCompany?.profileGenerationStatus),
        },
        GENERATE_PDF_REPORT: {
            name: 'Generate PDF Report',
            onClick: () => {
                trackGeneratePDFReport();
                window.open('/investor/app/pdf-report/' + selectedCompany?.assesseeOrgId);
            },
        },
        COMPOSE_EMAIL: {
            name: 'Compose Email',
            onClick: () => {
                dispatch(
                    setComposeEmailModal({
                        show: true,
                        selectedRequirements: [],
                        orgName: selectedCompany?.orgName,
                        source: COMPOSE_EMAIL_SOURCE.DASHBOARD_HEADER,
                    }),
                );
            },
        },
        MANAGE_USERS: {
            name: 'Manage Users',
            onClick: openManageUsersDrawer,
        },
    };
    const NotToShowLender = [
        'Create Deal',
        'Add to Portfolio',
        'Invite User',
        'Export Investment Report',
        'View One Pager',
        'Compose Email',
        'Manage Users',
        'View Engagement Letter',
        'View Bureau & KYC Consent',
        'View NDA',
    ];

    const pollingCount = useRef(0);
    const apiPollingRef: any = useRef(null);
    const [showTalkToUsModal, setShowTalkToUsModal] = useState(false);

    const trackGeneratePDFReport = () => {
        const mixpanelData = {
            'User Role': user?.userData?.accountType,
            'PNO Platform': getSubdomain(),
            'PNO ID': platformData?.investorOrgId,
            'User ID': user?.userData?.userId,
            'Current URL': window.location.href,
            'Organization ID': selectedCompany?.assesseeOrgId,
        };
        Mixpanel.track(AICA_GENERATE_PDF_REPORT, mixpanelData);
    };

    useEffect(() => {
        return () => {
            if (apiPollingRef?.current) clearInterval(apiPollingRef.current);
        };
    }, []);

    const fetchInvestmentReport = (rowData, pollingCount) => {
        pollingCount.current += 1;
        getInvestmentReport(
            { assesseeOrgId: params.id },
            {
                onSuccess: (data) => {
                    const reportGenStatus = data?.reportGenerationStatus;
                    if (pollingCount.current >= 5) {
                        clearInterval(apiPollingRef.current);
                        toast.error('Error in generating Investment Report');
                    } else {
                        if (reportGenStatus === GENERATION_STATUS.IN_PROGRESS) {
                            if (apiPollingRef.current) return;
                            apiPollingRef.current = setInterval(() => {
                                fetchInvestmentReport(pollingCount, rowData);
                            }, 10000);
                        } else if (reportGenStatus === GENERATION_STATUS.SUCCESS) {
                            if (apiPollingRef.current) clearInterval(apiPollingRef.current);
                            onInvestmentReportReceived({
                                fileName: data?.fileName,
                                docId: data?.fileUrl,
                                action: FILE_SHARE_STATUS.SEND_TO_INVESTOR,
                            });
                        }
                    }
                },
                onError: () => {
                    toast.error('Error in generating Investment Report');
                },
            },
        );
    };

    const onInvestmentReportReceived = (fileData) => {
        downloadGeneratedReport(fileData?.docId);
    };

    const downloadGeneratedReport = (documentId = '') => {
        downloadFile(
            Number(documentId),
            () => {
                toast.success('Investment Report downloaded successfully');
            },
            `Investment_Report`,
            () => {
                toast.error('Error in downloading Investment Report');
            },
        );
    };

    const hideUploader = () => {
        const params = new URLSearchParams(queryParams);
        params.delete('upload');
        params.delete('id');
        setQueryParams(params.toString());
    };

    const secondaryCtaList = () => {
        if (isUserRestricted) return [];
        let ctaList: { name: string; onClick: Function; keepOpenOnClick?: boolean }[] = [];
        if (selectedCompany?.companyAccessType !== ACCESS_TIERS.WATCH) {
            const triggers = dashboardConfig?.actionCta?.secondCTATrigger || [];
            ctaList = triggers
                .filter((trigger) => !(isSummonUser && trigger === 'SUMMON'))
                .reduce(
                    (p, c) => {
                        if (ACTION_MENU_MAP[c]) {
                            p.push({
                                ...ACTION_MENU_MAP[c],
                                keepOpenOnClick: ACTION_MENU_MAP[c].keepOpenOnClick,
                            });
                        }
                        return p;
                    },
                    [] as typeof ctaList,
                ) ?? [
                ...(isProfileLocked && !isPartner ? [{ name: 'Unlock AICA Report', onClick: unlockRefreshReport }] : []),

                ...(!isSummonUser ? [{ name: 'View Account', onClick: summon }] : []),
                ...(!isDemoProfile && !isLender && permissions?.TRACK !== ACCESS_TYPES.LOCKED && !isPartner
                    ? [
                          {
                              name: 'Create Deal',
                              onClick: openCreateDealDrawer,
                          },
                      ]
                    : []),

                {
                    name: 'View Bureau & KYC Consent',
                    onClick: () => {
                        trackViewBureauKycConsent();
                        dispatch(
                            setBureauKycConsentData({
                                open: true,
                                source: 'REPORT_TOP_BAR',
                                orgId: params.id as string,
                                companyName: selectedCompany?.orgName,
                            }),
                        );
                    },
                },
                ...(!isLender
                    ? [
                          {
                              name: 'Invite User',
                              onClick: () => {
                                  dispatch(setShowInviteUserModal(true));
                              },
                          },
                      ]
                    : []),
                ...(isPartner || isLender
                    ? []
                    : [
                          {
                              name: 'Add to Portfolio',
                              onClick: () =>
                                  addCompanyToPortfolio(
                                      selectedCompany?.assesseeOrgId,
                                      selectedCompany?.orgName,
                                      selectedCompany?.profileGenerationStatus,
                                  ),
                          },
                      ]),

                ...(!isPartner && !isLender
                    ? [
                          {
                              name: 'Export Investment Report',
                              onClick: () => {
                                  toast.warn(
                                      'Generating Investment Report.\n' +
                                          "It will automatically download within 2 mins, please don't close this tab.",
                                  );
                                  fetchInvestmentReport(selectedCompany, pollingCount);
                              },
                          },
                      ]
                    : []),
            ];
            if (isLender) {
                ctaList = ctaList.filter((item) => !NotToShowLender.includes(item.name));
            }
            // Filter out specific menu items for Partners
            if (isPartner) {
                const NotToShowPartner = [
                    'View One Pager',
                    'View NDA',
                    'Export Data',
                    'Export Investment Report',
                    'Add to Portfolio',
                    'Generate PDF Report',
                    'Create Deal',
                    'Compose Email',
                ];
                ctaList = ctaList.filter((item) => !NotToShowPartner.includes(item.name));
            }
        }
        return ctaList;
    };

    return (
        <div>
            <div className={styles.MainButtonContainer}>
                {HEADER_BUTTONS.mainButtons.map((button, index) => {
                    if (isEmpty(HEADER_BUTTONS.mainButtons)) return <></>;
                    else
                        return (
                            <div
                                key={index}
                                className={clsx({
                                    [styles.MainButton]: true,
                                    [styles.Purple]: button.variant === 'purple',
                                })}
                                onMouseEnter={() => setMainButtonHovered(button.id)}
                                onMouseLeave={() => setMainButtonHovered('')}
                            >
                                <img src={mainButtonHovered === button.id ? button.hoveredIcon : button.icon} alt="icon" />
                                <span>{button.title}</span>
                            </div>
                        );
                })}
                <ThreeDotMenu menuItems={secondaryCtaList()} />
            </div>
            {showUploader && (
                <SideDrawer
                    onClose={() => {
                        hideUploader();
                    }}
                    width="50%"
                >
                    <UploadData
                        userType={USER_TYPE.INVESTOR}
                        isInvestor
                        closeDrawer={() => {
                            hideUploader();
                        }}
                    />
                </SideDrawer>
            )}
            {showInviteUser && (
                <AddAssessee
                    assesseeOrgId={selectedCompany?.assesseeOrgId}
                    modalOpen={showInviteUser}
                    closeModal={() => {
                        dispatch(setShowInviteUserModal(false));
                    }}
                />
            )}

            {showManageUsers && (
                <ManageUserDrawer
                    onClose={() => {
                        searchParams.delete('category');
                        setSearchParams(searchParams);
                        setShowManageUsers(false);
                    }}
                    isOrgDrawer={true}
                    parentCategory={MANAGE_USERS_TABS.COMPANY}
                    selectedOrgName={selectedCompany?.orgName}
                    selectedUsers={selectedOrgUsers}
                />
            )}

            {showTalkToUsModal && (
                <NotificationModal
                    isOpen={showTalkToUsModal}
                    onClose={() => setShowTalkToUsModal(false)}
                    position="top-right"
                    header="Contact Us"
                    content="Contact your dedicated Relationship Manager"
                    footer={(() => {
                        const details = getOwnerDetails(userType);
                        return (
                            <div>
                                <div>
                                    {partnerOwner?.name && partnerOwner?.mobileNumber
                                        ? `${partnerOwner?.name}: (${
                                              partnerOwner?.countryCode ? `+${partnerOwner?.countryCode}` : '+91'
                                          }) ${partnerOwner?.mobileNumber}`
                                        : partnerOwner?.name && partnerOwner?.emailId
                                        ? `${partnerOwner?.name}: ${partnerOwner?.emailId}`
                                        : `${details.name}: (+91) ${details.phone}`}
                                </div>
                            </div>
                        );
                    })()}
                    source={NOTIFICATION_MODAL.CONTACT_US}
                />
            )}

            {/*{onePagerState.open && onePagerState.source === 'REPORT_TOP_BAR' && (*/}
            {/*    <OnePager*/}
            {/*        source={'REPORT_TOP_BAR'}*/}
            {/*        editorExistingData={editorExistingData as Object}*/}
            {/*        metadataUpdate={onMetadataUpdate}*/}
            {/*        categoryId={categoryId}*/}
            {/*        flowId={flowId}*/}
            {/*    />*/}
            {/*)}*/}
        </div>
    );
};

export default HeaderButtonContainer;
